import { Document, DocumentCode2, Key } from "iconsax-react";
import { CalendarDays, SlidersHorizontal } from "lucide-react";
import { Link, Outlet, useLocation } from "react-router-dom";

export default function ApiPage() {

    const location = useLocation();

    const tabs = [
        {
            id: 1,
            path: "/dashboard/settings/apis",
            key: "apis",
            name: "API Keys",
            icon: <Key size={20} />,
        },
        {
            id: 2,
            path: "/dashboard/settings/apis/documentation",
            key: "documentation",
            name: "Documentation",
            icon: <DocumentCode2 size={20} />,
        },
    ];

    const locationArr = location.pathname.split("/");
    const locationLastItems = locationArr.slice(locationArr.length - 1);


    return (
        <div className={`max-h-[90vh] bg-white`}>
            <div className="bg-[#fafafa] px-4 w-full border-r flex gap-x-2">
                {tabs.map((tab) => (
                    <Link
                        to={tab.path}
                        key={tab.id}
                        className={`flex items-center gap-x-3 px-3 rounded-md py-2 border-2 my-3 ${locationLastItems.includes(tab.key)
                                ? "text-primary border-primary-light"
                                : "text-black border-transparent"
                            } hover:border-primary-light text-sm`}
                    >
                        {tab.icon}
                        {tab.name}
                    </Link>
                ))}
            </div>

            <div className="basis-full border-t max-h-[75vh] overflow-y-scroll scrollbar-hide">
                <Outlet />
            </div>

        </div>
    )
}

